var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"base-pagination-trigger",on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.pageNumber !== 100000 ? _vm.pageNumber : '...')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }